/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//Custom JS for Airtable API

// var app, Airtable = require("airtable");

// function download_file(b, d) {
//   if (window.ActiveXObject) {
//     if (window.ActiveXObject && document.execCommand) {
//       var c = window.open(b, "_blank");
//       c.document.close(), c.document.execCommand("SaveAs", !0, d || b), c.close()
//     }
//   } else {
//     var a = document.createElement("a");
//     a.href = b, a.target = "_blank";
//     var e = b.substring(b.lastIndexOf("/") + 1);
//     if (a.download = d || e, navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && 0 > navigator.userAgent.search("Chrome")) document.location = a.href;
//     else {
//       var f = new MouseEvent("click", {
//         view: window,
//         bubbles: !0,
//         cancelable: !1
//       });
//       a.dispatchEvent(f), (window.URL || window.webkitURL).revokeObjectURL(a.href)
//     }
//   }
// }
// var base = new Airtable({
//   apiKey: "patevC9JQXpCVBa57.4d6d4e52ea6af94bea2b8dc08c2f1658cd281a6bf6c241a9aeae17c4f1737f9f"
// }).base("appfCHJQi0OuEx7qu");
// let airtableData = [],
//   sku = () => document.querySelector(".product-meta__sku-number").innerText,
//   getFiles = () => {
//     airtableData.length && (app.items = [], airtableData.forEach(a => {
//       -1 !== a.sku.indexOf(sku()) && (console.log(a), app.items.push(a))
//     }))
//   };
// var loadData = function() {
//   base('tblg7Jynl91dB1gZ6').select({
//     sort: [
//       {field: 'Sku(s)/Product(s)', direction: 'asc'}
//     ]
//   }).eachPage(function page(records, fetchNextPage) {
//     records.forEach(function(record) {
//       let c = record.get("Sku(s)/Product(s)") || [];
//       const sku_2 = record.get("Sku(s)/Product(s)_2") || [],
//             sku_3 = record.get("Sku(s)/Product(s)_3") || [];

//       let total_sku = [...c, ...sku_2, ...sku_3];
//       let sku = total_sku.join(" ").trim().split(" ");
//       sku = sku.filter(function(a) {
//         return a
//       });
//       if (total_sku) {
//         let d = {
//           id: record.getId(),
//           file: record.get("File URL"),
//           type: record.get("Type"),
//           sku: sku
//         };
//         airtableData.push(d), app.airtableData.push(d)
//       }
//     });

//     fetchNextPage();
//   }, function done(error) {
//     console.log(error), airtableData.length && (localStorage.setItem("airtableData", JSON.stringify(airtableData)), console.log("save the data to local storage")), getFiles(), document.querySelector("#airtable").classList.remove("op0"), document.querySelector(".card-loader").classList.add("op0");
//   });
// };

// document.addEventListener("variant:changed", function(a) {
//   var b = a.detail.variant;
//   console.log(b), app.items = [], console.log(`the items has ${app.items.length} items`), getFiles()
// }), app = new Vue({
//   el: "#airtable",
//   delimiters: ["${", "}"],
//   data: {
//     airtableData: [],
//     items: []
//   },
//   methods: {
//     download(a, b) {
//       download_file(a, b)
//     }
//   },
//   mounted() {
//     console.log("airtable called");
//     let a = localStorage.getItem("airtableData");
//     a ? (console.log("fetch from local storage"), airtableData = JSON.parse(a), this.items = [], airtableData.forEach(a => {a != undefined && a.sku != undefined &&
//       -1 !== a.sku.indexOf(sku()) && (console.log(a), console.log(sku()), this.items.push(a))
//     }), this.items.length ? (document.querySelector("#airtable").classList.remove("op0"), document.querySelector(".card-loader").classList.add("op0")) : (console.log("new data if no items"), loadData())) : (console.log("new data"), loadData())
//   }
// });


// Custom JS for Airtable API
// var Airtable = require("airtable");

// function download_file(b, d) {
//   if (window.ActiveXObject) {
//     if (window.ActiveXObject && document.execCommand) {
//       var c = window.open(b, "_blank");
//       c.document.close(), c.document.execCommand("SaveAs", !0, d || b), c.close();
//     }
//   } else {
//     var a = document.createElement("a");
//     a.href = b; a.target = "_blank";
//     var e = b.substring(b.lastIndexOf("/") + 1);
//     if (a.download = d || e, navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && 0 > navigator.userAgent.search("Chrome")) document.location = a.href;
//     else {
//       var f = new MouseEvent("click", { view: window, bubbles: !0, cancelable: !1 });
//       a.dispatchEvent(f); (window.URL || window.webkitURL).revokeObjectURL(a.href);
//     }
//   }
// }

// // Airtable config
// var base = new Airtable({
//   apiKey: "patevC9JQXpCVBa57.4d6d4e52ea6af94bea2b8dc08c2f1658cd281a6bf6c241a9aeae17c4f1737f9f"
// }).base("appfCHJQi0OuEx7qu");

// let sku = () => document.querySelector(".product-meta__sku-number").innerText;

// // Vue instance
// app = new Vue({
//   el: "#airtable",
//   delimiters: ["${", "}"],
//   data: {
//     airtableData: [], // all Airtable records
//     items: [],        // filtered items for current SKU
//     loading: true     // reactive loading state
//   },
//   methods: {
//     download(a, b) {
//       download_file(a, b);
//     },

//     // Filter Airtable data for current SKU and prevent duplicates
//     getFiles() {
//       this.items = [];
//       const seen = new Set();
//       this.airtableData.forEach(record => {
//         if (record.sku.includes(sku()) && !seen.has(record.id)) {
//           this.items.push(record);
//           seen.add(record.id);
//         }
//       });

//       // Toggle .op0 for Airtable and loader
//       this.$nextTick(() => {
//         const airtableEl = document.querySelector("#airtable");
//         const loaderEl = document.querySelector(".card-loader");
//         if (airtableEl) airtableEl.classList.remove("op0");
//         if (loaderEl) loaderEl.classList.add("op0");
//       });
//     },

//     // Load data from Airtable
//     loadData() {
//       this.airtableData = [];

//       base('tblg7Jynl91dB1gZ6').select({
//         sort: [{ field: 'Sku(s)/Product(s)', direction: 'asc' }]
//       }).eachPage((records, fetchNextPage) => {
//         records.forEach(record => {
//           const c = record.get("Sku(s)/Product(s)") || [];
//           const sku_2 = record.get("Sku(s)/Product(s)_2") || [];
//           const sku_3 = record.get("Sku(s)/Product(s)_3") || [];

//           const total_sku = [...c, ...sku_2, ...sku_3].filter(a => a).map(s => s.trim());

//           this.airtableData.push({
//             id: record.getId(),
//             file: record.get("File URL"),
//             type: record.get("Type"),
//             sku: total_sku
//           });
//         });

//         fetchNextPage();
//       }, error => {
//         if (error) console.log(error);

//         if (this.airtableData.length) {
//           localStorage.setItem("airtableData", JSON.stringify(this.airtableData));
//           console.log("Saved data to local storage");
//         }

//         this.getFiles();
//       });
//     }
//   },
//   mounted() {
//     console.log("airtable called");

//     this.airtableData = [];
//     this.items = [];
//     this.loading = true; // start loading

//     let stored = localStorage.getItem("airtableData");
//     if (stored) {
//       console.log("fetch from local storage");
//       this.airtableData = JSON.parse(stored);
//       this.getFiles();
//     } else {
//       console.log("new data");
//       this.loadData();
//     }
//   }
// });

// // Update items on variant change
// document.addEventListener("variant:changed", function(event) {
//   console.log(event.detail.variant);
//   if (app) app.getFiles(); // refresh items safely
// });



if (document.body.classList.contains('template-product')) {
  var Airtable = require("airtable");

  function download_file(b, d) {
    var a = document.createElement("a");
    a.href = b;
    a.target = "_blank";
    a.download = d || "";
    a.click();
  }

  // Airtable config
  var base = new Airtable({
    apiKey: "patevC9JQXpCVBa57.4d6d4e52ea6af94bea2b8dc08c2f1658cd281a6bf6c241a9aeae17c4f1737f9f"
  }).base("appfCHJQi0OuEx7qu");

  // Vue instance
  var app = new Vue({
    el: "#airtable",
    delimiters: ["${", "}"],
    data: {
      airtableData: [],
      items: [],
      currentSku: null
    },
    methods: {
      download(a, b) {
        download_file(a, b);
      },

      // Filter Airtable data by CURRENT SKU (no DOM access)
      getFiles() {
        this.items = [];
        if (!this.currentSku) return;

        const seen = new Set();

        this.airtableData.forEach(record => {
          if (record.sku.includes(this.currentSku) && !seen.has(record.id)) {
            this.items.push(record);
            seen.add(record.id);
          }
        });

        // Toggle loader visibility
        this.$nextTick(() => {
          const airtableEl = document.querySelector("#airtable");
          const loaderEl = document.querySelector(".card-loader");
          if (airtableEl) airtableEl.classList.remove("op0");
          if (loaderEl) loaderEl.classList.add("op0");
        });
      },

      // Load all Airtable records once
      loadData() {
        this.airtableData = [];

        base("tblg7Jynl91dB1gZ6")
          .select({
            sort: [{ field: "Sku(s)/Product(s)", direction: "asc" }]
          })
          .eachPage((records, fetchNextPage) => {
            records.forEach(record => {
              const c1 = record.get("Sku(s)/Product(s)") || [];
              const c2 = record.get("Sku(s)/Product(s)_2") || [];
              const c3 = record.get("Sku(s)/Product(s)_3") || [];

              const allSkus = [...c1, ...c2, ...c3]
                .filter(Boolean)
                .map(s => s.trim());

              this.airtableData.push({
                id: record.getId(),
                file: record.get("File URL"),
                type: record.get("Type"),
                sku: allSkus
              });
            });

            fetchNextPage();
          }, err => {
            if (err) console.error(err);

            localStorage.setItem("airtableData", JSON.stringify(this.airtableData));
            this.getFiles();
          });
      }
    },

    mounted() {
      // Initial SKU on page load
      const skuEl = document.querySelector(".product-meta__sku-number");
      this.currentSku = skuEl ? skuEl.innerText.trim() : null;

      const stored = localStorage.getItem("airtableData");
      if (stored) {
        this.airtableData = JSON.parse(stored);
        this.getFiles();
      } else {
        this.loadData();
      }
    }
  });

  // ✅ FIXED variant handling (NO LAG)
  document.addEventListener("variant:changed", function (event) {
    if (!event.detail || !event.detail.variant) return;

    // Update SKU immediately from Shopify variant object
    app.currentSku = event.detail.variant.sku;

    // Refresh links with correct SKU
    app.getFiles();
  });
}





////////// DON'T REMOVE THIS CODE //////////

// /* Conditions in Cart page */
// function initCartOrderDisposition() {
//   const cartForm = document.querySelector(".cart-recap");
//   if (!cartForm) return;

//   const checkoutButton = cartForm.querySelector('button[name="checkout"]');
//   const dispositionRadios = cartForm.querySelectorAll('input[name="order_disposition"]');
//   const noteTextarea = cartForm.querySelector('textarea[name="note"]');

//   if (!checkoutButton || dispositionRadios.length === 0) return;

//   // Disable checkout button on load
//   checkoutButton.disabled = true;
//   checkoutButton.classList.add("button--disabled");

//   // Create hidden internal note if it doesn't exist
//   let internalNote = cartForm.querySelector('input[name="attributes[internal_order_note]"]');
//   if (!internalNote) {
//     internalNote = document.createElement("input");
//     internalNote.type = "hidden";
//     internalNote.name = "attributes[internal_order_note]";
//     cartForm.appendChild(internalNote);
//   }

//   // Map radio values to admin-facing order notes
//   const dispositionMap = {
//     ship_all: "Disposition: Ship Complete",
//     send_partial: "Disposition: Ship Partial"
//   };

//   dispositionRadios.forEach(radio => {
//     radio.addEventListener("change", () => {
//       if (!radio.checked) return;

//       // ✅ Enable checkout
//       checkoutButton.disabled = false;
//       checkoutButton.classList.remove("button--disabled");

//       // ✅ Handle radio-card selected state
//       cartForm.querySelectorAll(".radio-card").forEach(card => {
//         card.classList.remove("radio-selected");
//       });

//       const radioCard = radio.closest(".radio-card");
//       if (radioCard) {
//         radioCard.classList.add("radio-selected");
//       }

//       // Resolve mapped admin note
//       let finalNote = dispositionMap[radio.value] || "Disposition: Unknown";

//       // Detect special order items
//       const hasSpecial = Array.from(
//         cartForm.querySelectorAll(".line-item__stock-status")
//       ).some(el => el.textContent.trim() === "Special Order Item");

//       if (hasSpecial) {
//         finalNote = `Special Order Item(s) Present\n${finalNote}`;
//       }

//       // Set cart attribute (Additional details)
//       internalNote.value = finalNote;

//       // Set REAL Shopify order note (Admin → Notes)
//       if (noteTextarea) {
//         noteTextarea.value = finalNote;
//       }

//       console.log("Order note set:", finalNote);
//     });
//   });

//   // Optional notice text update
//   const hasSpecialOrder = Array.from(
//     cartForm.querySelectorAll(".line-item__stock-status")
//   ).some(el => el.textContent.trim() === "Special Order Item");

//   if (hasSpecialOrder) {
//     const orderNotice = cartForm.querySelector(
//       ".cart-order-condition .order-disposition-title"
//     );
//     if (orderNotice) {
//       orderNotice.textContent =
//         "Items in your order are either special order, partially out-of-stock, or backordered. Please select a fulfillment preference:";
//     }
//   }
// }

// // Run on page load
// document.addEventListener("DOMContentLoaded", initCartOrderDisposition);

// // Re-run after AJAX cart updates
// document.addEventListener("cart:rerendered", initCartOrderDisposition);

////////// DON'T REMOVE THIS CODE //////////




// Forcing Product Increment Selections (Supports ft + pkg)
document.addEventListener("DOMContentLoaded", function () {

  let increment = null;

  function getIncrementFromTags() {
    if (!window.productTags || !Array.isArray(window.productTags)) return null;

    // Priority: pkg first, then ft
    const pkgTag = window.productTags.find(tag =>
      tag.startsWith("product_qty_pkg_")
    );

    if (pkgTag) {
      return parseInt(pkgTag.replace("product_qty_pkg_", ""), 10);
    }

    const ftTag = window.productTags.find(tag =>
      tag.startsWith("product_qty_ft_")
    );

    if (ftTag) {
      return parseInt(ftTag.replace("product_qty_ft_", ""), 10);
    }

    return null;
  }

  function initializeIncrement() {
    increment = getIncrementFromTags();

    // Default increment = 1 if no tag
    if (!increment || isNaN(increment) || increment <= 0) {
      increment = 1;
    }

    fixAttributes();
  }

  // ---- FORCE MIN ATTRIBUTE & RESET EMPTY ----
  function fixAttributes() {
    document.querySelectorAll("quantity-picker input[name='quantity']")
      .forEach(input => {

        input.setCustomValidity("");
        input.setAttribute("min", increment);
        input.min = increment;

        // Remove step to avoid browser auto snapping
        input.removeAttribute("step");

        const current = parseInt(input.value);

        if (!input.value || isNaN(current) || current < increment) {
          input.value = increment;
        }
      });
  }

  // Initial run
  initializeIncrement();

  // ---- RE-RUN AFTER VARIANT CHANGE ----
  document.addEventListener("product:rerender", function () {
    setTimeout(function () {
      initializeIncrement();
    }, 250);
  });

  // ---- CORRECT QUANTITY FUNCTION ----
  function correctQuantity(input, triggerChange = false) {

    let raw = parseInt(input.value);

    if (isNaN(raw) || raw < increment) {
      input.value = increment;
    } else {
      const corrected = Math.ceil(raw / increment) * increment;
      if (corrected !== raw) {
        input.value = corrected;
      }
    }

    if (triggerChange) {
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // ---- ROUND ON BLUR ----
  document.addEventListener("focusout", function (e) {
    if (e.target.name !== "quantity") return;
    correctQuantity(e.target, true);
  });

  // ---- OVERRIDE stepUp / stepDown ----
  const originalStepUp = HTMLInputElement.prototype.stepUp;
  const originalStepDown = HTMLInputElement.prototype.stepDown;

  HTMLInputElement.prototype.stepUp = function () {
    if (this.name === "quantity") {
      const current = parseInt(this.value) || increment;
      this.value = current + increment;
      this.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    originalStepUp.apply(this, arguments);
  };

  HTMLInputElement.prototype.stepDown = function () {
    if (this.name === "quantity") {
      const current = parseInt(this.value) || increment;
      let newValue = current - increment;
      if (newValue < increment) newValue = increment;
      this.value = newValue;
      this.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    originalStepDown.apply(this, arguments);
  };

  // ---- FIX BEFORE ADD TO CART ----
  document.querySelectorAll("form[action*='/cart/add']").forEach(form => {
    form.addEventListener("submit", function () {
      const input = form.querySelector("input[name='quantity']");
      if (!input) return;
      correctQuantity(input, false); // No extra change event
    });
  });

});